<div class="annex-form-wrapper">
  <div class="import-wrapper">
    <button nz-button nzType="primary" (click)="importAnnex()">
      {{ 'ANNEX.ANNEX_IMPORT' | translate }}
    </button>
  </div>

  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">
    <nz-divider [nzText]="entityGivingJobSectionTitle" nzOrientation="center">
      <ng-template #entityGivingJobSectionTitle>
        <h2>{{ 'ANNEX.ANNEX_1' | translate }} - {{ 'MANAGEMENT.COMPANY_DETAILS.ENTITY_GIVING_JOB' | translate }}</h2>
      </ng-template>
    </nz-divider>
    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSpan]="6">
        <nz-form-item>
          <nz-form-control>
            <nz-radio-group formControlName="workplace_usingPersonName">
              <label nz-radio [nzValue]="false">{{ 'COMMON.LABEL.COMPANY_NAME' | translate }}</label>
              <label nz-radio [nzValue]="true">{{ 'COMMON.LABEL.FULL_NAME' | translate }}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <ng-container *ngIf="form.get('workplace_usingPersonName').value === false">
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="6">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="workplace_name">
              {{ 'COMMON.LABEL.NAME' | translate }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="inputStandardErrors">
              <input nz-input formControlName="workplace_name" id="workplace_name" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="form.get('workplace_usingPersonName').value === true">
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="workplace_name">
              {{ 'COMMON.LABEL.FIRST_NAME' | translate }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="inputStandardErrors">
              <input nz-input formControlName="workplace_name" id="workplace_name" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
          <nz-form-item>
            <nz-form-label [nzRequired]="form.get('workplace_usingPersonName')?.value" nzFor="workplace_surname">
              {{ 'COMMON.LABEL.SURNAME' | translate }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="inputStandardErrors">
              <input nz-input formControlName="workplace_surname" id="workplace_surname" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </ng-container>
    <nz-divider [nzText]="section1" nzOrientation="center">
      <ng-template #section1>
        <h3>
          {{ 'COMMON.LABEL.ENTITY_ADDRESS' | translate }}
        </h3>
      </ng-template>
    </nz-divider>
    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="6">
        <nz-form-item>
          <nz-form-control>
            <nz-radio-group formControlName="workplace_addressOutsideCountry">
              <label nz-radio [nzValue]="false">{{ 'COMMON.LABEL.IN_COUNTRY_ADDRESS' | translate }}</label>
              <label nz-radio [nzValue]="true">{{ 'COMMON.LABEL.ADDRESS_OUTSIDE_COUNTRY' | translate }}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <app-mos-annex-address
      [initialData]="annex"
      [form]="form"
      [fp]="'workplace_'"
      [voivodeships]="voivodeships"
      [countries]="countries">
    </app-mos-annex-address>
    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="workplace_legalBasisOfBusiness">
            {{ 'ANNEX.LEGAL_BASIS_OF_PERFORMING_BUSINESS' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <textarea
              formControlName="workplace_legalBasisOfBusiness"
              id="workplace_legalBasisOfBusiness"
              nz-input
              placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
              [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <nz-divider [nzText]="section2" nzOrientation="center">
      <ng-template #section2>
        <h3>
          {{ 'COMMON.LABEL.OTHER_FORMS_OF_ENTITY_IDENTIFICATION' | translate }}
        </h3>
      </ng-template>
    </nz-divider>
    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="workplace_pesel">
            {{ 'COMMON.LABEL.PESEL' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <input nz-input formControlName="workplace_pesel" id="workplace_pesel" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzFor="workplace_regon">
            {{ 'COMMON.LABEL.REGON' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <input nz-input formControlName="workplace_regon" id="workplace_regon" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- ========================================= ERRORS FOR INPUTS TEMPLATE ================================================================== -->
    <ng-template #inputStandardErrors let-control>
      <ng-container *ngIf="control.hasError('maxlength')">{{
        'COMMON.VALIDATOR.MAX_LENGTH_EXCEEDED' | translate
      }}</ng-container>
      <!-- <ng-container *ngIf="control.hasError('minlength')">MinLength is 6</ng-container> -->
      <ng-container *ngIf="control.hasError('required')">
        {{ 'COMMON.VALIDATOR.FIELD_IS_REQUIRED' | translate }}</ng-container
      >
    </ng-template>
    <!-- ========================================= ERRORS FOR INPUTS TEMPLATE END ================================================================== -->

    <!-- ============================================================= PROXY PART ================================================================== -->
    <nz-divider [nzText]="entityProxyingJobSectionTitle" nzOrientation="center">
      <ng-template #entityProxyingJobSectionTitle>
        <h2>{{ 'ANNEX.ANNEX_1' | translate }} - {{ 'ANNEX.ENTITY_PROXYING_JOB' | translate }}</h2>
      </ng-template>
    </nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="hasSeparateEmployer">{{
              'ANNEX.HAS_SEPARATE_EMPLOYER' | translate
            }}</label>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <ng-container *ngIf="form.get('hasSeparateEmployer')?.value === true">
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-control>
              <nz-radio-group formControlName="employer_usingPersonName">
                <label nz-radio [nzValue]="false">{{ 'COMMON.LABEL.COMPANY_NAME' | translate }}</label>
                <label nz-radio [nzValue]="true">{{ 'COMMON.LABEL.FULL_NAME' | translate }}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <ng-container *ngIf="form.get('employer_usingPersonName').value === false">
        <div nz-row [nzGutter]="8">
          <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="6">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="employer_name">
                {{ 'COMMON.LABEL.NAME' | translate }}
              </nz-form-label>
              <nz-form-control [nzErrorTip]="inputStandardErrors">
                <input nz-input formControlName="employer_name" id="employer_name" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="form.get('employer_usingPersonName').value === true">
        <div nz-row [nzGutter]="8">
          <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="employer_firstname">
                {{ 'COMMON.LABEL.FIRST_NAME' | translate }}
              </nz-form-label>
              <nz-form-control [nzErrorTip]="inputStandardErrors">
                <input nz-input formControlName="employer_name" id="employer_firstname" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
            <nz-form-item>
              <nz-form-label [nzRequired]="form.get('employer_usingPersonName')?.value" nzFor="employer_surname">
                {{ 'COMMON.LABEL.SURNAME' | translate }}
              </nz-form-label>
              <nz-form-control [nzErrorTip]="inputStandardErrors">
                <input nz-input formControlName="employer_surname" id="employer_surname" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </ng-container>
      <nz-divider [nzText]="section1" nzOrientation="center">
        <ng-template #section1>
          <h3>
            {{ 'COMMON.LABEL.ENTITY_ADDRESS' | translate }}
          </h3>
        </ng-template>
      </nz-divider>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-control>
              <nz-radio-group formControlName="employer_addressOutsideCountry">
                <label nz-radio [nzValue]="false">{{ 'COMMON.LABEL.IN_COUNTRY_ADDRESS' | translate }}</label>
                <label nz-radio [nzValue]="true">{{ 'COMMON.LABEL.ADDRESS_OUTSIDE_COUNTRY' | translate }}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <app-mos-annex-address
        [initialData]="annex"
        [form]="form"
        [fp]="'employer_'"
        [voivodeships]="voivodeships"
        [countries]="countries">
      </app-mos-annex-address>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="employer_legalBasisOfBusiness">
              {{ 'ANNEX.LEGAL_BASIS_OF_PERFORMING_BUSINESS' | translate }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="inputStandardErrors">
              <textarea
                formControlName="employer_legalBasisOfBusiness"
                id="employer_legalBasisOfBusiness"
                nz-input
                placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
                [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <nz-divider [nzText]="section2" nzOrientation="center">
        <ng-template #section2>
          <h3>
            {{ 'COMMON.LABEL.OTHER_FORMS_OF_ENTITY_IDENTIFICATION' | translate }}
          </h3>
        </ng-template>
      </nz-divider>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
          <nz-form-item>
            <nz-form-label nzFor="employer_pesel">
              {{ 'COMMON.LABEL.PESEL' | translate }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="inputStandardErrors">
              <input nz-input formControlName="employer_pesel" id="employer_pesel" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
          <nz-form-item>
            <nz-form-label nzFor="employer_regon">
              {{ 'COMMON.LABEL.REGON' | translate }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="inputStandardErrors">
              <input nz-input formControlName="employer_regon" id="employer_regon" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </ng-container>

    <nz-divider [nzText]="jobInfoSection" nzOrientation="center">
      <ng-template #jobInfoSection>
        <h2>{{ 'ANNEX.ANNEX_1' | translate }} - {{ 'ANNEX.INFORMATION_ABOUT_PAID_ACITIVITY' | translate }}</h2>
      </ng-template>
    </nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="positionName">
            {{ 'ANNEX.POSITION' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <textarea
              formControlName="positionName"
              id="positionName"
              nz-input
              placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
              [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzFor="classificationOfOccupation">
            {{ 'ANNEX.CLASSIFICATION_OF_OCCUPATION' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <textarea
              formControlName="classificationOfOccupation"
              id="classificationOfOccupation"
              nz-input
              placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
              [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider [nzText]="placeOfJobSection" nzOrientation="center">
      <ng-template #placeOfJobSection>
        <h3>
          {{ 'ANNEX.PLACE_OF_JOB' | translate }}
        </h3>
      </ng-template>
    </nz-divider>

    <app-mos-annex-address
      [initialData]="annex"
      [form]="form"
      [fp]="'place_'"
      [voivodeships]="voivodeships"
      [countries]="countries">
    </app-mos-annex-address>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="legalBasisOfPaidActivity">
            {{ 'ANNEX.LEGAL_BASIS_OF_PAID_ACTIVITY' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-select
              id="legalBasisOfPaidActivity"
              formControlName="legalBasisOfPaidActivity"
              nzPlaceHolder="{{ 'COMMON.PLACEHOLDER.SELECT_BASIS' | translate }}">
              <nz-option *ngFor="let basis of legalBasisOfWork" [nzValue]="basis" [nzLabel]="basis"> </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="contractType">
            {{ 'ANNEX.CONTRACT_TYPE' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-radio-group id="contractType" formControlName="contractType">
              <label nz-radio [nzValue]="'EMPLOYMENT'">{{ 'ANNEX.CONTRACT_TYPE_EMPLOYMENT' | translate }}</label>
              <label nz-radio [nzValue]="'CIVIL_LAW'">{{ 'ANNEX.CONTRACT_TYPE_CIVIL_LAW' | translate }}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="6">
        <nz-form-item *ngIf="form.get('contractType')?.value !== 'CIVIL_LAW'">
          <nz-form-label nzRequired nzFor="contractType">
            {{ 'ANNEX.WORKING_TIME_AT_FULLTIME' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-input-number
              id="contractType"
              formControlName="workingTime"
              [nzPrecision]="3"
              nzPrecisionMode="cut"
              nzPlaceHolder="0.001"
              style="width: 100%"
              [attr.aria-label]="'ANNEX.WORKING_TIME_AT_FULLTIME' | translate">
            </nz-input-number>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="form.get('contractType')?.value === 'CIVIL_LAW'">
          <nz-form-label nzRequired nzFor="workHoursPerWeek">
            {{ 'ANNEX.NUMBER_OF_WORKING_HOURS' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-input-number
              id="workHoursPerWeek"
              formControlName="workHoursPerWeek"
              [nzPrecision]="2"
              nzPrecisionMode="cut"
              nzPlaceHolder="0.01"
              style="width: 100%"
              [attr.aria-label]="'ANNEX.NUMBER_OF_WORKING_HOURS' | translate">
            </nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider [nzText]="renumerationSection" nzOrientation="center">
      <ng-template #renumerationSection>
        <h3>
          {{ 'ANNEX.PROPOSED_RENUMERATION' | translate }}
        </h3>
      </ng-template>
    </nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="typeOfPayGross">
            {{ 'ANNEX.RENUMERATION_TYPE' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="typeOfPayGross">
              <label nz-radio [nzValue]="'MONTHLY'">{{ 'ANNEX.RENUMERATION_MONTHLY' | translate }}</label>
              <label nz-radio [nzValue]="'YEARLY'">{{ 'ANNEX.RENUMERATION_YEARLY' | translate }}</label>
              <label nz-radio [nzValue]="'HOURLY'">{{ 'ANNEX.RENUMERATION_HOURLY' | translate }}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row nzGutter="12">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="grossAmount">
            {{ 'ANNEX.GROSS_AMOUNT' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-input-number
              id="grossAmount"
              formControlName="grossAmount"
              [nzPrecision]="2"
              nzPrecisionMode="cut"
              nzPlaceHolder="1.00"
              style="width: 100%"
              [attr.aria-label]="'ANNEX.GROSS_AMOUNT' | translate">
            </nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="mainDuties">
            {{ 'ANNEX.MAIN_DUTIES' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <textarea
              formControlName="mainDuties"
              id="mainDuties"
              [maxlength]="490"
              nz-input
              placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
              [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider [nzText]="blueCardSection" nzOrientation="center">
      <ng-template #blueCardSection>
        <h2>{{ 'ANNEX.ANNEX_2' | translate }} - {{ 'ANNEX.BLUE_CARD' | translate }}</h2>
      </ng-template>
    </nz-divider>

    <nz-divider [nzText]="periodSection" nzOrientation="center">
      <ng-template #periodSection>
        <h3>
          {{ 'ANNEX.PAID_ACTIVITY_PERIOD' | translate }}
        </h3>
      </ng-template>
    </nz-divider>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="periodOfWorkFrom">
            {{ 'ANNEX.PERIOD_OF_WORK_FROM' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <nz-date-picker
              id="periodOfWorkFrom"
              formControlName="periodOfWorkFrom"
              [nzFormat]="'dd.MM.yyyy'"
              nzPlaceHolder="DD.MM.YYYY"
              style="width: 100%"
              [attr.aria-label]="'ANNEX.PERIOD_OF_WORK_FROM' | translate">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="periodOfWorkTo">
            {{ 'ANNEX.PERIOD_OF_WORK_TO' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <nz-date-picker
              id="periodOfWorkTo"
              formControlName="periodOfWorkTo"
              [nzFormat]="'dd.MM.yyyy'"
              nzPlaceHolder="DD.MM.YYYY"
              style="width: 100%"
              [attr.aria-label]="'ANNEX.PERIOD_OF_WORK_TO' | translate">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="qualificationsType">
            {{ 'ANNEX.QUALIFICATIONS_TYPE' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <textarea
              formControlName="qualificationsType"
              id="qualificationsType"
              nz-input
              placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
              [nzAutosize]="{ minRows: 3, maxRows: 6 }"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="qualificationsDocument">
            {{ 'ANNEX.QUALIFICATIONS_DOCUMENT' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="inputStandardErrors">
            <textarea
              formControlName="qualificationsDocument"
              id="qualificationsDocument"
              nz-input
              placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
              [nzAutosize]="{ minRows: 3, maxRows: 6 }"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="hasBlueCard">
            {{ 'ANNEX.HAS_BLUE_CARD' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-radio-group id="hasBlueCard" formControlName="hasBlueCard">
              <label nz-radio [nzValue]="true">{{ 'COMMON.GENERAL.YES' | translate }}</label>
              <label nz-radio [nzValue]="false">{{ 'COMMON.GENERAL.NO' | translate }}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <ng-container *ngIf="form.get('hasBlueCard')?.value === true">
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="blueCardCountry">
              {{ 'COMMON.LABEL.COUNTRY' | translate }}
            </nz-form-label>
            <nz-form-control>
              <nz-select
                id="blueCardCountry"
                formControlName="blueCardCountry"
                nzPlaceHolder="{{ 'COMMON.PLACEHOLDER.SELECT_COUNTRY' | translate }}"
                [nzShowSearch]="true">
                <nz-option *ngFor="let country of blueCardCountries" [nzValue]="country" [nzLabel]="country">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="blueCardCountryPeriodOfStay">
              {{ 'ANNEX.PERIOD_OF_STAY' | translate }}
            </nz-form-label>
            <nz-form-control>
              <textarea
                id="blueCardCountryPeriodOfStay"
                formControlName="blueCardCountryPeriodOfStay"
                nz-input
                placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
                [nzAutosize]="{ minRows: 1, maxRows: 3 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="blueCardSerial">
              {{ 'COMMON.LABEL.SERIES' | translate }}
            </nz-form-label>
            <nz-form-control>
              <input id="blueCardSerial" formControlName="blueCardSerial" nz-input />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="blueCardNumber">
              {{ 'COMMON.LABEL.NUMBER' | translate }}
            </nz-form-label>
            <nz-form-control>
              <input id="blueCardNumber" formControlName="blueCardNumber" nz-input />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
          <nz-form-item>
            <nz-form-label nzRequired>
              {{ 'ANNEX.DATE_OF_ISSUE' | translate }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="inputStandardErrors">
              <nz-date-picker
                formControlName="blueCardDateOfIssue"
                [nzFormat]="'dd.MM.yyyy'"
                nzPlaceHolder="DD.MM.YYYY"
                style="width: 100%"
                [attr.aria-label]="'ANNEX.DATE_OF_ISSUE' | translate">
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="12" [nzSm]="12" [nzMd]="6">
          <nz-form-item>
            <nz-form-label nzRequired>
              {{ 'ANNEX.DATE_OF_EXPIRY' | translate }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="inputStandardErrors">
              <nz-date-picker
                formControlName="blueCardExpiryDate"
                [nzFormat]="'dd.MM.yyyy'"
                nzPlaceHolder="DD.MM.YYYY"
                style="width: 100%"
                [attr.aria-label]="'ANNEX.DATE_OF_EXPIRY' | translate">
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12">
          <nz-form-item>
            <nz-form-label nzRequired>
              {{ 'ANNEX.BLUE_CARD_ISSUER' | translate }}
            </nz-form-label>
            <nz-form-control>
              <textarea
                formControlName="blueCardIssuer"
                id="blueCardIssuer"
                nz-input
                placeholder="{{ 'COMMON.VALIDATOR.FILL_FIELD' | translate }}"
                [nzAutosize]="{ minRows: 1, maxRows: 3 }">
              </textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </ng-container>
  </form>
</div>
